<template>
<div class='homepage'>
  <navTop :choosed='1'></navTop>
  <centerMap ref="centerMap" :tabsIndex="tabsIndex" :tippos="tippos" :rainData="rainData"  @setRow="setRow"></centerMap>
  <rainLeft ref="rainLeft" v-if="tabsIndex==0" @rePosition="rePosition" @getRain="getRain" @showPoint="showPoint" @showDialog="showDialog"></rainLeft>
  <rainRight v-if="tabsIndex==0" @showimg="showimg" @changeMap="changeMapType"></rainRight>
  <waterLeft ref="waterLeft" v-if="tabsIndex==1"  @rePosition="rePosition" @showPoint="showPoint" @showDialog="showDialog"></waterLeft>
  <waterRight ref="waterRight" v-if="tabsIndex==1" @showPoint="showPoint" @showDialog="showDialog" @changeMap="changeMapType"></waterRight>
  <div class="tabs flexDiv">
    <div class="tabsli" v-for="(item,index) in tabsli" :key="index" @click="tabsliClick(item,index);initMap();closeDialog()">
      <div :class="{'activeColor':tabsIndex===index}">{{item}}</div>
      <div class="leftB" :class="{'activeBorder':tabsIndex===index}"></div>
      <div class="rightB" :class="{'activeBorder':tabsIndex===index}"></div>
    </div>
  </div>
  <div class="printerBtn" :class="{'printerleft':tippos}">
    <el-button type="primary" icon="el-icon-printer" circle @click="printMap"></el-button>
  </div>
  <el-image-viewer
    v-if="showViewer"
    :on-close="()=>{showViewer = false}"
    :url-list="urllist" />
</div>
</template>

<script>

import navTop from '@/components/nav'
import centerMap from './components/centermap'
import rainLeft from './components/rain_left'
import rainRight from './components/rain_right'
import waterLeft from './components/water_left'
import waterRight from './components/water_right'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: {
    navTop,
    centerMap,
    rainLeft,
    rainRight,
    waterLeft,
    waterRight,
    ElImageViewer
  },
  data () {
    return {
      tabsli: ['雨情监测', '水情监测', '风险一张图'],
      tabsIndex: 0,
      urllist: [],
      showViewer: false,
      tippos: false,
      rainData: [],
      mapInit: 3 // 默认地图
    }
  },
  computed: {},
  watch: {},
  methods: {
    printMap () {
      this.$refs.centerMap.printer.printMap('CurrentSize', 'MyManualPrint')
    },
    initMap () { // 切换雨情，水情tab时，地图初始化
      this.$refs.centerMap.radioChange(this.mapInit)
    },
    changeMapType (val) {
      this.$refs.centerMap.radioChange(val)
    },
    getRain (data) {
      this.rainData = data
    },
    showimg (url) {
      this.urllist = url
      this.showViewer = true
    },
    rePosition (pageshow) {
      this.tippos = pageshow
    },
    showPoint (data) {
      console.log(data)
      this.$refs.centerMap.showPoint(data)
    },
    showDialog (data) {
      this.$refs.centerMap.showDialog(data)
    },
    closeDialog (data) {
      this.$refs.centerMap.closeDialog(data)
    },
    tabsliClick (item, index) {
      if (item === '风险一张图') {
        this.$router.push({
          name: 'riskchart'
        })
      } else {
        this.tabsIndex = index
        this.tippos = false
      }
    },
    setRow (id, sttp) {
      if (this.tabsIndex === 0) {
        this.$refs.rainLeft.setRow(id)
      } else if (this.tabsIndex === 1) {
        if (sttp.includes('RR')) {
          this.$refs.waterLeft.setRow(id)
          this.$refs.waterRight.$refs.riverTable.setCurrentRow()
        } else if (sttp.includes('ZZ')) {
          this.$refs.waterRight.setRow(id)
          this.$refs.waterLeft.$refs.reservoirTable.setCurrentRow()
        }
      }
    }
  },
  created () {
  },
  mounted () {
    if (this.$route.params.tabsIndex === 0 || this.$route.params.tabsIndex === 1) {
      this.tabsIndex = this.$route.params.tabsIndex
    }
  }
}
</script>
<style lang='less' scoped>
.homepage{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.tabs{
  width: 680px;
  height: 40px;
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  margin: auto;
  background: rgba(0,0,0,0.1);
  z-index: 500;
  color: #fff;
  font-size: 22px;
  border: 1px solid #0dadf0;
  border-radius: 5px;
  *{
    box-sizing: border-box;
  }
  .tabsli{
    width: 220px;
    margin: 0 10px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    position: relative;
    cursor: pointer;
  }
  .leftB{
    width: 20px;
    height: 32px;
    position: absolute;
    left: 0px;
    top: -1px;
    border-right: 0!important;
  }
  .rightB{
    width: 20px;
    height: 32px;
    position: absolute;
    right: 0px;
    top: -1px;
    border-left: 0!important;
  }
  .activeBorder{
    border: 2px solid #21fffb;
  }
  .activeColor{
    color: #00eaff;
    background: rgba(24,126,228,0.3);
  }
}
.printerBtn{
  position: absolute;
  top: 80px;
  left: 560px;
  z-index: 1999;
  transition: all 1s ease;
}
.printerleft{
  left: 20px;
}
.flexDiv {
    /* 横向排列 */
    display: flex;
    align-items: center;
}

.flexSA {
  /* 每个项目两侧的间隔相等 */
  justify-content: space-around;
}
/deep/.el-image-viewer__close{
  color: #fff;
}
</style>
